import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
  name: 'specialityDetails'
})
export class SpecialityDetailsPipe implements PipeTransform {
  private facilitiesList: any;
  constructor(private user: UserService) {
    // Use sync access since data should already be loaded
    const data = this.user.getUpdateInfoSync('facilityServices');
    this.facilitiesList = data ? data.facilities : [];
  }
  transform(value: any, fId: any, key: string): any {
    // Fallback to sync access if data wasn't available during construction
    if (!this.facilitiesList || this.facilitiesList.length === 0) {
      const data = this.user.getUpdateInfoSync('facilityServices');
      this.facilitiesList = data ? data.facilities : [];
    }
    
    let val = this.facilitiesList.filter(fac => {
      return fac.facilityId == fId;
    })[0]
    if (val) {
      val = val['specialities'].filter(spec => {
        return spec.specialityId == value;
      })[0]
      val= val?val[key]:'';
    }
    return val;
  }

}
